import { render, staticRenderFns } from "./lifeturn.vue?vue&type=template&id=017ed508&scoped=true"
import script from "./lifeturn.vue?vue&type=script&lang=js"
export * from "./lifeturn.vue?vue&type=script&lang=js"
import style0 from "./lifeturn.vue?vue&type=style&index=0&id=017ed508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017ed508",
  null
  
)

export default component.exports